import React from 'react'
import { useChatWhatsApp } from '../../../../context/ChatWhatsAppContext'
import { useQueryClient } from '@tanstack/react-query'
import { useAuth } from '../../../../context/AuthContext'
import { useFilaTransbordo } from '../../../../context/FilaTransbordoContext'
import { RequestAcionamento } from '../../../../types/resgitro-acionamento-interface'
import { usePropostas } from '../../../../context/PropostasContext'
import { useDividas } from '../../../../context/DividasContext'
import { useModal } from '../../../../hooks/ModalContext'
// import { useNeg } from '../../../../../context/NegContext'
import { useContrato } from '../../../../context/ContratoContext'

// template: { template: TemplateProps }
export const TemplateTransbordo = () => {
  const { enviarMessages } = useChatWhatsApp()
  const { devedorFilaSelected } = useFilaTransbordo()
  const { devedor, selectedCredor } = useDividas()
  const { cookies } = useAuth()
  const queryClient = useQueryClient()
  const { sendAcionamento } = usePropostas()
  const { setModal } = useModal();
  // const { contratoNeg } = useNeg()
  const { contratosData } = useContrato()

  async function finalizarAcordo(idacionamento: string, observacao: string,) {
    const acionamento: RequestAcionamento = {
      app: 'ACIONA_WEB',
      cpfCnpj: devedorFilaSelected.chatData.cpfDevedor,
      credor: String(selectedCredor?.credor_crm),
      empresa: 'GAZIN',
      idacionamento,
      observacao,
      stage: '0',
      url: selectedCredor.url_ws,
      telefone: '',
      tipo: 'POSICAO',
      usuario: String(cookies?.user?.id_operador),
      agendamento: ``,
      telefoneagendamento: '',
      contrato: contratosData.contratos[0].numcontrato,
    }
    await sendAcionamento(acionamento)

  }

  async function handleClick() {
    if (devedor?.cpf_cnpj && selectedCredor?.credor_crm && contratosData.contratos[0].numcontrato) {
      await finalizarAcordo('20101', 'Inicio Atendimento Transbordo')
      await enviarMessages({ type: 'text', text: `Olá, sou ${cookies?.user?.nome?.split(' ')[0]}. Como posso te ajudar?`, onlySave: false, token: cookies?.whatsapp?.token || '', chat: devedorFilaSelected._id })
      await queryClient.refetchQueries({ queryKey: ['firstMessages'] })
    } else if (devedorFilaSelected._id && !devedorFilaSelected?.chatData?.cpfDevedor) {
      await enviarMessages({ type: 'text', text: `Olá, sou ${cookies?.user?.nome?.split(' ')[0]}. Como posso te ajudar?`, onlySave: false, token: cookies?.whatsapp?.token || '', chat: devedorFilaSelected._id })
      await queryClient.refetchQueries({ queryKey: ['firstMessages'] })
    }
    else {
      setModal('Por favor, aguarde o carregamento da tela de cadastro.', 'Aviso', false, true)
    }
  }

  return (
    <div className='grid grid-cols-2 gap-1 text-xs text-ellipsis w-full'>
      <div className='bg-white flex justify-center p-2 cursor-pointer rounded-md hover:brightness-95 ' onClick={() => handleClick()}>
        <p>TEMPLATE DE ABERTURA</p>
      </div>
    </div>
  )
}